import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { DisclaimerService } from '../disclaimer.service';
import { TranslatedNotificationService } from '../../shared/translation/translated-notification.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-disclaimer',
  templateUrl: './disclaimer.component.html',
  styleUrls: ['./disclaimer.component.scss']
})
export class DisclaimerComponent implements OnInit, OnDestroy {
  disclaimerOpened = false;
  subscription: Subscription;
  gdprUrl: SafeResourceUrl;

  constructor(
    private service: DisclaimerService,
    private notificationService: TranslatedNotificationService,
    private sanitizer: DomSanitizer) {
    this.subscription = new Subscription();
  }

  ngOnInit() {
    this.service.GetUserSeenGdpr()
      .subscribe((hasSeen) => {
        if (hasSeen == undefined || hasSeen == null || hasSeen == false) {
          this.openDisclaimer();
        }
      },
        (err) => {
          this.notificationService.showMsgError(
            'error.loading_gdpr',
            'Sorry, loading GDPR data is not possible now. Please try again later.');
        });

    this.subscription.add(
      this.service.privacyNotice$.subscribe(() => {
        this.openDisclaimer();
      }
      )
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  closeDisclaimer() {
    this.disclaimerOpened = false;
    this.subscription.add(this.service.UpdateUserSeenGdpr().subscribe());
  }

  openDisclaimer() {
    this.disclaimerOpened = true;
    const cacheBuster = new Date().getTime();
    const urlWithCacheBuster = `${environment.gdprUrl}?v=${cacheBuster}`;
    this.gdprUrl = this.sanitizer.bypassSecurityTrustResourceUrl(urlWithCacheBuster);
  }
}
